import React from 'react'
import SuperUserTxnPageUI from '../../../templates/SuperUserTxnPageUI.js'
import ExternalTxnListUI from '../../../components/superUser/nodalTxn/ExternalTxnListUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'

const ExternalTxnListPageUI = ({ context, accountNumber, bankTxnList, totalAmount, totalAmountF1,
  crAmountF1Map, drAmountF1Map, totals,
  onCopyToClipboard, copyToClipboardText,
  onRefreshClick
}) =>
  <SuperUserTxnPageUI context={context} className='pg_su_recon' topnav='transactions' backLink='/su/accounts'
    headerText='Accounts' centered={!bankTxnList} dimension='w768'
    page={accountNumber === '007105010733' ? '0733external' : '4441external'}
  >
    {
      (!bankTxnList) &&
      <SpinnerComponentUI />
    }
    {
      bankTxnList &&
      <ExternalTxnListUI
        context={context}
        accountNumber={accountNumber}
        bankTxnList={bankTxnList}
        totalAmount={totalAmount}
        totalAmountF1={totalAmountF1}
        crAmountF1Map={crAmountF1Map}
        drAmountF1Map={drAmountF1Map}
        totals={totals}
        onRefreshClick={onRefreshClick}
        onCopyToClipboard={onCopyToClipboard}
        copyToClipboardText={copyToClipboardText}
      />
    }

  </SuperUserTxnPageUI>

export default ExternalTxnListPageUI
